import { Switch, styled } from '@material-ui/core';

export const SwitchButton = styled(Switch)({
  overflow: 'visible',
  '& .MuiSwitch-track': {
    opacity: 0.2,
  },
  '& .MuiSwitch-switchBase': {
    top: '-0.2rem',
    '&.Mui-checked + .MuiSwitch-track': {
      opacity: 1,
    },
  },
});
